export default "__VITE_ASSET__Dwp0Rj4z__"